import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With over 16 years of experience, you've led transformative initiatives in banking
                platforms. What key architectural principles do you follow when implementing
                scalable and secure banking systems in the digital age?
              </strong>
            </h5>

            <h5 className="text-white">
              Over the past decade-plus I’ve helped build and modernize banking platforms on four
              continents, and along the way I’ve settled on five principles that keep systems
              secure, scalable, and—just as important—ready for the next big idea:
              <br />
              <ul>
                <li>
                  Security in the DNA, not bolted on later I start every user story with a quick
                  threat-model conversation, then bake controls straight into our CI/CD pipelines.
                  If a release can’t prove it meets our regulatory and data-protection requirements,
                  it doesn’t ship—simple as that.
                </li>
                <li>
                  Domain-driven and composable I break the bank into product-aligned
                  domains—payments, onboarding, lending—each with its own data and contract-first
                  APIs. That lets teams move at different speeds, scale only what really needs to
                  scale, and spin up new fintech partnerships in weeks instead of quarters.
                </li>
                <li>
                  Event-streaming at the core Real-time banking means real-time plumbing, so we put
                  critical events—fraud alerts, balance updates, KYC checks—on a streaming backbone.
                  Services stay loosely coupled, but they all react instantly when something
                  important happens.
                </li>
                <li>
                  Unified observability and governance I’m a big believer in “digital guardrails.”
                  Logs, traces, and even AI-model telemetry land on the same dashboard so business,
                  risk, and tech see one version of the truth and spot trouble early—whether it’s
                  latency or model drift.
                </li>
                <li>
                  Data as a Live Asset, Ready for AI We treat data the way product teams treat
                  features—curated, versioned, richly catalogued, and constantly fed by model
                  feedback. Each prediction makes the next one smarter, so when the business wants a
                  new risk dashboard or an LLM-powered assistant, we can wire it up in days, not
                  months.
                </li>
              </ul>
              <br />
              These principles have powered everything from QIIB’s AI-driven mobile search to
              multilingual intent recognition and enterprise RPA. The payoff? Faster feature
              delivery, a stronger security posture, and a platform that can evolve as quickly as
              our customers’ expectations do.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- You’ve pioneered the use of RPA and AI for critical banking functions. How do you
                determine which banking processes to automate, and how do you ensure these systems
                enhance both efficiency and customer satisfaction?
              </strong>
            </h5>
            <h5 className="text-white">
              I apply two guiding principles when identifying automation opportunities: alignment
              with strategic business needs and severity of operational pain points. This ensures we
              tackle the most impactful processes first.
              <br />
              <ul>
                <li>
                  Business Needs: We map automation proposals to key strategic objectives—whether
                  it’s faster onboarding, higher transaction throughput, or improved compliance.
                </li>
                <li>
                  Pain Points: We prioritize processes that cause the biggest delays, error rates,
                  or customer frustrations.
                </li>
              </ul>
              <br />
              Within that framework, I look for:
              <br />
              <ul>
                <li>
                  High-Volume, Repetitive Tasks – Data entry, reconciliations, report
                  generation—ideal for RPA to cut cycle times and reduce errors.
                </li>
                <li>
                  Customer-Facing Interactions – Conversational AI, smart search, or multilingual
                  intent recognition—where AI can elevate service quality and personalization.
                </li>
                <li>
                  Risk & Compliance-Intensive Workflows– Know-Your-Customer checks, regulatory
                  reporting—where automation boosts accuracy, auditability, and controls.
                </li>
              </ul>
              <br />
              To ensure both efficiency and satisfaction:
              <br />
              <ul>
                <li>
                  Lean & Optimize First: We re-engineer processes to eliminate waste before
                  automating.
                </li>
                <li>
                  Customer-Centric Design: AI interfaces are tested for clarity, speed, and empathy
                  across channels.
                </li>
                <li>
                  Metrics-Driven Monitoring: We establish KPIs—error rates, turnaround times, and
                  NPS—feeding into continuous improvement loops.
                </li>
              </ul>
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your ability to lead cross-functional teams is central to your success. What’s
                your approach to fostering collaboration between technical and non-technical teams
                during a tech project?
              </strong>
            </h5>
            <h5 className="text-white">
              Bringing technical and non-technical teams together is one of the parts of my job I
              enjoy the most. Working across the globe, I’ve learned that real collaboration rests
              on three things: clarity, inclusion, and cultural empathy.
              <br />
              <ul>
                <li>
                  Start with a Clear, Shared Vision - I open every project by explaining why it
                  matters in plain language. When business colleagues hear how an API or a
                  machine-learning model translates into faster onboarding or better risk control,
                  they lean in—and the engineers see the bigger purpose behind the code.
                </li>
                <li>
                  Create Inclusive Ways of Working - I run joint workshops where product, risk, and
                  tech colleagues sketch the user journey on the same whiteboard. We agree on
                  success metrics together, so everyone feels ownership rather than hand-offs.
                </li>
                <li>
                  Respect Cultural Nuances - Having worked with teams across the globe, I’ve learned
                  to adapt my communication style—whether that means extra context for a risk team
                  in Mexico or concise bullet points for developers in Doha. Small adjustments build
                  trust quickly.
                </li>
              </ul>
              <br />
              This approach helped us roll out AI-powered mobile search and enterprise-wide RPA
              without friction: engineers delivered on time, operations saw fewer errors, and
              customers felt the difference.
              <br />
              <br />
              Ultimately, I feel that collaboration is about more than processes—it’s about building
              trust, aligning visions, and unifying teams across functions and cultures.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve implemented cutting-edge technologies like NLP and robotics. Which emerging
                technologies will most impact banking in the next 3–5 years, and how are you
                preparing for them?
              </strong>
            </h5>
            <h5 className="text-white">
              I’m convinced the next wave of disruption will come from three converging forces:
              large language models, predictive AI, and autonomous orchestration. Together they
              promise a leap from “digital banking” to thinking banking—systems that anticipate,
              decide, and act in real time.
              <br />
              <ul>
                <li>
                  Large Language Models (LLMs) as the New UX - We’re already prototyping LLMs for
                  multilingual intent recognition, smart document reading, and on-the-fly product
                  explanation. Imagine a virtual adviser that knows your spending habits, speaks
                  your language, and can fill a loan form while you chat.
                </li>
                <li>
                  Predictive & Prescriptive AI for Risk and Revenue - We’re running early use-cases
                  that turn raw data into forward-looking signals—think proactive fraud alerts or
                  next-best-offer engines. As these models mature, banks will shift from reacting to
                  events to anticipating them, improving safety and unlocking new revenue streams.
                </li>
                <li>
                  Intelligent Process Automation - We’re evolving classic RPA into event-driven bots
                  that handle repetitive, error-prone work—salary processing, reconciliations,
                  operations approvals—without human babysitting. Staff can then focus on
                  exceptions, insight, and relationship-building.
                </li>
              </ul>
              <br />
              My goal is simple: by the time these technologies go mainstream, we’re not scrambling
              to adopt them—we’re refining them to delight customers and create new revenue streams.
              Banking should feel less like software and more like a trusted, proactive companion.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
